import React, { useState, useEffect, useContext } from "react";
import {
  SafeAreaView,
  Text,
  StyleSheet,
  View,
  TouchableOpacity,
  Platform,
} from "react-native";

import moment from "moment";

import Icons from "../../common/icons/index";
import Utils from "../../../../helpers/utils";
import headerStyles from "../../common/header/headerStyles";
import AppTheme from "../../AppTheme";
import JournalContext from "../JournalContext";
import appStyles from "../../../appStyles";

import ManaHHmm from "../../common/ManaHHmm";

export default function TrackDetailHeader({
  timeslot,
  journalContext,
  controller,
  openJournalDialog,
  toggleTimePickerDialog,
  goBack,
}) {
  const { tutorialStep } = journalContext || {};

  const [selectedDate, setSelectedDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [meridian, setMeridian] = useState("");
  const [duration, setDuration] = useState("");

  // Tutorials
  const highlightEndStyle = tutorialStep == 1 ? appStyles.highlightTime : {};

  useEffect(() => {
    if (!timeslot || !timeslot.id) return;

    const startTimeModel = moment(timeslot.time);
    const endTimeModel = moment(timeslot.endDate);
    const diff = endTimeModel.diff(startTimeModel, "minutes");

    setEndTime(endTimeModel.format("hh:mm"));
    setMeridian(endTimeModel.format("a"));
    setDuration(diff / 60);

    const times = timeslot.startTime.split(" ");
    if (times[0]) setStartTime(times[0]);

    // Selected date
    const dateSelected = timeslot.time
      ? moment(timeslot.time)
      : Utils.nowUserTz(controller);

    setSelectedDate(dateSelected.format("ddd, MMM DD"));
  }, [timeslot]);

  return (
    <SafeAreaView style={styles.container}>
      {timeslot && timeslot.id ? (
        <View style={styles.content}>
          <View style={headerStyles.leftContainer}>
            <Icons.Back onPress={goBack} />
          </View>

          <View style={styles.interval}>
            <TouchableOpacity
              style={styles.hours}
              onPress={toggleTimePickerDialog}
            >
              <Text style={[styles.time, styles.underline]}>{startTime}</Text>
              <Text style={[styles.time, styles.separator]}>-</Text>
              <TouchableOpacity
                style={highlightEndStyle}
                onPress={toggleTimePickerDialog}
              >
                <Text style={[styles.time, styles.underline]}>{endTime}</Text>
              </TouchableOpacity>
              <Text style={styles.meridian}>{meridian}</Text>
              {duration ? <ManaHHmm duration={duration} /> : null}
            </TouchableOpacity>
            <Text style={[styles.date]}>{selectedDate}</Text>
          </View>

          <View style={headerStyles.rightContainer}>
            <Icons.Journal
              onPress={openJournalDialog}
              mood={timeslot.mood}
              width={20}
              height={20}
              fillColor={AppTheme.iconBlack}
            />
          </View>
        </View>
      ) : null}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: AppTheme.headerBg,
  },
  content: {
    position: "relative",
    minHeight: 90,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
  },
  interval: {
    paddingLeft: 54,
  },
  hours: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    minWidth: 125,
  },
  time: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.title,
  },
  separator: {
    paddingHorizontal: 5,
  },
  underline: {
    borderBottomWidth: 1,
    borderBottomColor: AppTheme.title,
  },
  date: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "500",
    letterSpacing: 0.5,
    fontSize: 12,
    lineHeight: 15,
    color: AppTheme.title,
    paddingTop: 2,
  },
  meridian: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    textTransform: "lowercase",
    paddingTop: 5,
    color: AppTheme.title,
    marginRight: 5,
  },
});
